import { Logo } from 'src/shared/components/icons/logos/logo'
import { useSignOut } from 'src/shared/features/auth/api'
import useBreakpoint from 'src/shared/hooks/use-breakpoint'

import AppWindowFrameEnterprise from './navigation/app-window-frame-enterprise'

// interface MobileTabButtonConfig {
//   iconName: IconName
//   name: string
//   path: string
// }

// const tabButtons: MobileTabButtonConfig[] = [
//   // {
//   //   iconName: 'house',
//   //   name: 'Home',
//   //   path: paths.enterprise.dashboard.path,
//   // },
//   {
//     iconName: 'people',
//     name: 'Directory',
//     path: paths.enterprise.dashboard.directory.path,
//   },
//   // {
//   //   iconName: 'briefcase',
//   //   name: 'Performances',
//   //   path: paths.enterprise.dashboard.performances.path,
//   // },
//   // {
//   //   iconName: 'document',
//   //   name: 'Pipeline',
//   //   path: paths.enterprise.dashboard.pipeline.path,
//   // },
//   // {
//   //   iconName: 'document',
//   //   name: 'Billing',
//   //   path: paths.enterprise.dashboard.billing.path,
//   // },
// ]

interface EnterpriseDashboardLayoutProps {
  children: React.ReactNode
}

export function EnterpriseDashboardLayout({ children }: EnterpriseDashboardLayoutProps) {
  const { isMobile } = useBreakpoint()
  // const location = useLocation()

  // const activeTabIdx = tabButtons.findIndex(
  //   (tab) => location.pathname === tab.path || location.pathname.startsWith(tab.path + '/'),
  // )

  return (
    <>
      <meta name="theme-color" content="#1B3029" />
      {isMobile ? (
        // <EnterpriseDashboardMobileLayout tabButtons={tabButtons} selectedTab={activeTabIdx}>
        //   {children}
        // </EnterpriseDashboardMobileLayout>
        <TempMobileBlockLayout />
      ) : (
        <AppWindowFrameEnterprise>{children}</AppWindowFrameEnterprise>
      )}
    </>
  )
}

function TempMobileBlockLayout() {
  const signOut = useSignOut({ isEnterprise: true })

  return (
    <div className="flex min-h-screen w-full flex-col items-center bg-[#F8F7F5]">
      <div className="pt-[80px]">
        <Logo showCircleR={false} className="h-[30px] w-[145px] text-primary" />
      </div>

      <div className="flex flex-1 items-center px-[35px]">
        <div className="flex w-[320px] flex-col items-center gap-[10px] rounded-[40px] bg-white px-[10px] pb-[30px] pt-[32px] text-center">
          <h1 className="text-[26px] font-semibold leading-tight tracking-[-0.26px] text-primary">
            Continue on desktop
          </h1>
          <p className="text-[15px] font-medium leading-[1.6] text-[#606F6A]">Mobile version coming soon</p>
          <button
            onClick={() => signOut.mutateAsync()}
            className="mt-5 flex h-[55px] w-[270px] items-center justify-center rounded-full bg-primary"
          >
            <span className="text-[15px] font-semibold text-white">Go home</span>
          </button>
        </div>
      </div>
    </div>
  )
}

// interface EnterpriseDashboardMobileLayoutProps {
//   children: React.ReactNode
//   tabButtons: MobileTabButtonConfig[]
//   selectedTab: number
// }

// function EnterpriseDashboardMobileLayout({ children, tabButtons, selectedTab }: EnterpriseDashboardMobileLayoutProps) {
//   const signOut = useSignOut({ isEnterprise: true })

//   const handleLogout = () => {
//     signOut.mutateAsync()
//   }

//   return (
//     <div className="flex max-h-screen w-full flex-col overflow-hidden">
//       <div
//         className={cn(
//           'w-full flex-1 overflow-y-auto',
//           ScrollBarTailwindClassesDefault,
//           '[&::-webkit-scrollbar-track]:my-0',
//         )}
//       >
//         {children}
//       </div>
//       <div className="h-[75px] w-full shrink-0 bg-transparent"></div>
//       <div
//         className={cn(
//           'fixed bottom-0 left-0 right-0 z-20 h-[75px]',
//           'border-t-[0.5px] border-lightBorder bg-white shadow-[0_-3px_12px_0_rgba(27,48,41,0.05)]',
//         )}
//       >
//         <div className="flex w-full flex-row items-center justify-between px-5 pb-[20px]">
//           {tabButtons.map((tabButton, index) => (
//             <Link to={tabButton.path} key={tabButton.name} className="relative flex-1">
//               {selectedTab === index && (
//                 <motion.div
//                   initial={{ scaleX: 0 }}
//                   animate={{ scaleX: 1 }}
//                   transition={{ duration: 0.2 }}
//                   className="absolute inset-x-0 top-0 h-[2px] rounded-b-[2px] bg-primary"
//                 />
//               )}
//               <div
//                 className={cn(
//                   'flex flex-col items-center justify-center gap-[6px] pt-[15px] text-muted',
//                   selectedTab === index && 'text-primary',
//                 )}
//               >
//                 <TabButtonIcon name={tabButton.iconName} className="size-[20px]" />
//                 <span className="text-[10px] font-medium leading-none">{tabButton.name}</span>
//               </div>
//             </Link>
//           ))}
//           <div className="relative flex-1">
//             <div className={cn('flex flex-col items-center justify-center gap-[6px] pt-[15px] text-muted')}>
//               <div className="box-content flex size-[24px] shrink-0 items-center justify-center rounded-full border-[3px] border-white bg-muted">
//                 <BuildingFilled size={10} className="text-[#D8D8D6]" />
//               </div>
//               <span className="text-[10px] font-medium leading-none">Menu</span>
//             </div>
//           </div>
//           {/* Temp Logout Button */}
//           <div className="relative flex-1 cursor-pointer" onClick={() => handleLogout()}>
//             <div className={cn('flex flex-col items-center justify-center gap-[6px] pt-[15px] text-muted')}>
//               <div className="box-content flex size-[24px] shrink-0 items-center justify-center rounded-full border-[3px] border-white bg-muted">
//                 <LogoutIcon className="size-[10px]" color="#D8D8D6" />
//               </div>
//               <span className="text-[10px] font-medium leading-none">Log out</span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   )
// }
